export default __webpack_public_path__ + "static/media/group-6493.7e04700b.png";